var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "field",
    { attrs: { label: _vm.label, disabled: _vm.disabled, inline: _vm.inline } },
    [
      _c("dropdown-field", {
        attrs: {
          source: _vm.packageVersionSource,
          "key-field": "rowNo",
          "auto-assign": _vm.autoAssign,
          clearable: _vm.clearable,
          placeholder: _vm.placeholder,
        },
        scopedSlots: _vm._u([
          {
            key: "item-text",
            fn: function ({ item }) {
              return [
                item !== null
                  ? _c("span", [
                      _vm._v(
                        _vm._s(item.versionName) +
                          " - " +
                          _vm._s(_vm.formatDate(item.asOfDate))
                      ),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
        model: {
          value: _vm.val,
          callback: function ($$v) {
            _vm.val = $$v
          },
          expression: "val",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }